import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import { format } from '@mixins/decimal';
import Model from '@models/model';

export default class ProposalTankExchange extends Model {
    constructor(...props) {
        super();
        this.item = {};
        this.setAttributes(...props);
    }

    resource() {
        return 'tank-exchanges';
    }

    get formFieldCasts() {
        return {
            rent_per_month: CurrencyFormatter.formFormat,
            exchange_price: CurrencyFormatter.formFormat,
            commodity_surcharge_amount: CurrencyFormatter.formFormat,
            environmental_fee_amount: CurrencyFormatter.formFormat,
        };
    }

    get propCasts() {
        return {
            qty: format,
        };
    }
}
